module.exports = __webpack_public_path__ + "7be904632d0871afbebee2b99a62cab2.svg";